/**
 * Created by rhinov15 on 05/02/2016.
 *
 * Display room secondary functionalities (TV...)
 */
//TODO Remove brut url and use server url when server allow CORS

import { GameObjectManager } from "../GameObjectManager";
import { CocosConstants } from "../../../../constants";
import { PlanManager } from "../../../../cocosPlan";
import { Events, eventsManager, FunctionalityChip } from "@rhinov/savane-js";

declare var cc: any;


export class FunctionalityChipNode extends cc.Sprite{
    constructor(chip: FunctionalityChip) {
        // Call parent constructor
        super();
        // Set the correct image into the sprite to display
        this.front = new cc.Sprite((GameObjectManager.roomFunctionalitiesData as any)[chip.functionality!].medias.md);
        // Set anchor, scale and position of the sprite within the node
        this.front.setAnchorPoint(-0.18, -0.18);
        this.front.setScale(0.75);
        this.front.setPosition(0, 0);
        // Add the node to the display hierarchie
        this.addChild(this.front, 1);

        // Store the chip being displayed to be used when it's state changes
        this.chip = chip;

        // Keep the current texture name in a member variable
        this.holdTexture = (GameObjectManager.roomFunctionalitiesData as any)[chip.functionality!].medias.md;

        // Set the background of the current node (circle within which the image will be drawn)
        this.setTexture(CocosConstants.resourcesBasePath + '/resources/chipBack.png');
        // And scale
        this.setScale(0.75 / PlanManager.getInstance().getZoomScale());
    }

    // The current node is selected or not ?
    setSelected (value: boolean) {
        // If selected
        if (value) {
            // Change the node texture to the selected version of the sprite
            this.holdTexture = (GameObjectManager.roomFunctionalitiesData as any)[this.chip.functionality].selected.md;
            this.front.setTexture((GameObjectManager.roomFunctionalitiesData as any)[this.chip.functionality].selected.md);
            // Old code to be removed
            /*            this.chipLabel.setVisible(true);
                        this.setTextureRect(new cc.Rect(0,0,64,64));*/
        }
        else {
            // Change the node texture to the normal version of the sprite
            this.holdTexture = (GameObjectManager.roomFunctionalitiesData as any)[this.chip.functionality].medias.md;
            this.front.setTexture((GameObjectManager.roomFunctionalitiesData as any)[this.chip.functionality].medias.md);
            // Old code to be removed
            /*            this.chipLabel.setVisible(false);
                        this.setTextureRect(new cc.Rect(64,0,64,64));*/
        }
    }

    // The current node is invalid or not ?
    setInvalid (value: boolean) {
        if (!value) {
            // Change the node texture to the normal version of the sprite
            this.front.setTexture((GameObjectManager.roomFunctionalitiesData as any)[this.chip.functionality].invalid.md);
        }
        else {
            // Change the node texture to the previously loaded version of the sprite
            this.front.setTexture(this.holdTexture);
        }
    }

    // Update current sprite texture
    updateImage () {
        this.front.setTexture((GameObjectManager.roomFunctionalitiesData as any)[this.chip.functionality].medias.md);
    }

    /**
     * Remove listener added for zoomUpdate
     */
    removeListener () {
        eventsManager.instance.removeListener(this.hideListener);
        eventsManager.instance.removeListener(this.scrollListener);
    }

    // Object creation, create scroll and hide listeners
    onEnter () {
        // Call super class to initialise parent fields
        super.onEnter();

        // Create listeners for zom change
        this.scrollListener = eventsManager.instance.addListener(Events.ZOOM_SCROLLWIN_CHANGED, function (this: FunctionalityChipNode, event: any) {
            this.setScale(0.75 / event.getUserData());
        }.bind(this));

        // And hide chips change
        this.hideListener = eventsManager.instance.addListener(Events.HIDE_CHIPS, function (this: FunctionalityChipNode, event: any) {
            this.setVisible(false);
        }.bind(this));
    }

    // Object destruction
    onExit () {
        // Destroy parent class fields
        super.onExit();
        // Destroy the listeners created above
        this.removeListener();
    }
 }
